<template>
    <ModalContainer :visible="visible" :loading="loading">
        <template v-slot:header>
            <button type="button" class="close"  @click="$emit('close-client-modal')"><i class="las la-times"></i></button>
            <h4 class="modal-title">{{ $t('components.client.update') }}</h4>
        </template>
        <template v-slot:body>
            <div class="form-group" v-show="errorMessage">
                <div class="alert alert-danger" style="margin: 0 10px;">
                    {{errorMessage}}
                </div>
            </div>
            <ClientExtendForm  @change="onChangeClient" :new-client-prop="client"></ClientExtendForm>
        </template>

        <template v-slot:footer>
            <a class="btn btn-primary btn-lg btn-block"
               href=""
               @click.prevent.stop="UpdateClient()">
                <i class="las la-check"></i>
                <span>{{ $t('components.client.update') }}</span>
            </a>
        </template>
    </ModalContainer>
</template>

<script>
import ClientExtendForm from "@/components/client/ClientExtendForm";
import {updateClient} from "@/api";
import ModalContainer from "./ModalContainer";
import i18n from "../../i18n"

export default {
    name: "UpdateClientModal",
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        client: {
            type: Object,
            required: true
        }
    },
    data: () => {
        return {
            loading: false,
            updateClient: {
            },
            errorMessage:""
        }
    },
    components: {ModalContainer, ClientExtendForm},
    methods: {
        onChangeClient(client) {
            this.updateClient = Object.assign({}, client);
        },
        async UpdateClient() {
            this.errorMessage = "";
            this.loading = true;
            try {
                await updateClient(this.updateClient.id, this.updateClient.first_name, this.updateClient.last_name,
                    this.updateClient.email, this.updateClient.phone_number_international, this.updateClient.acsi_card,
                    this.updateClient.note );

                this.$emit('success-update-client');
                this.loading = false;
                this.$route.params.successMessage = i18n.t('components.client.updated');

            } catch (e) {
                this.loading = false;
                console.log(e)
            }
        },
    },
    watch: {
        client(newVal) {
            this.updateClient = Object.assign({}, newVal);
        }
    }
};
</script>